import { defineMessages } from 'react-intl';

export default defineMessages({
  selectServiceText: {
    description: 'Text to display when a Service has not already been selected',
    defaultMessage: 'Select service',
    id: 'M5nDIp',
  },
  clearSelectionsButtonText: {
    description: 'Text to display when a user wants to clear all selections from the Carrier Service Selector',
    defaultMessage: 'Clear',
    id: 'juB5Lb',
  },
  applySelectionsButtonText: {
    description: 'Text to display when a user wants to apply the selections they made in the Carrier Service Selector',
    defaultMessage: 'Apply',
    id: 'c2T1K4',
  },
  emptyCarrierServicesWarning: {
    description: 'Warning message to display when there are no Carrier Services to display',
    defaultMessage:
      'You currently have no active services on your account. You must first <a>enable services</a> to create a Shippping Strategy.',
    id: 'h6fIM1',
  },
});
